import Area, { IArea } from "./Area";
import Application from "../Application";
import { IRouter } from "../runtime/Router";
import ShowReport3PageInteractor from "../interactor/report/ShowReport3PageInteractor";
import Report3Page from "../ui/pages/reports/Report3Page";
import ShowReport5PageInteractor from "../interactor/report/ShowReport5PageInteractors";
import Report5Page from "../ui/pages/reports/Report5Page";
import Report4Page from "../ui/pages/reports/Report4Page";
import Report2Page from "../ui/pages/reports/Report2Page";
import ShowReport2PageInteractor from "../interactor/report/ShowReport2PageInteractor";
import Report8Page from "../ui/pages/reports/Report8Page";
import ShowReport4Interactor from "../interactor/report/ShowReport4PageInteractor";
import ShowReport8PageInteractor from "../interactor/report/ShowReport8PageInteractor";
import Report6Page from "../ui/pages/reports/Report6Page";
import ShowReport6PageInteractor from "../interactor/report/ShowReport6PageInteractor";
import ShowReport1PageInteractor from "../interactor/report/ShowReport1PageInteractor";
import Report1Page from "../ui/pages/reports/Report1Page";
import { RoleConstants } from "../common/Constants";
import ShowPublicationsReportPageInteractor from "../interactor/report/ShowPublicationsReportPageInteractor";
import PublicationsReportPage from "../ui/pages/reports/PublicationsReportPage";
import ShowReport7PageInteractor from "../interactor/report/ShowReport7PageInteractor";
import Report7Page from "../ui/pages/reports/Report7Page";

export default class ReportsArea extends Area implements IArea {
  private application: Application;
  private router: IRouter;

  constructor(application: Application, router: IRouter) {
    super();
    this.application = application;
    this.router = router;
  }

  register(params: any) {
    this.router.registerRoutes({
      path: "/reports/1",
      page: this.createPage({
        Page: Report1Page,
        action: this.showReport1Page.bind(this)
      }),
      options: {
        secure: true,
        role: [RoleConstants.MIK_BO.MIK_OSOBLJE]
      }
    });

    this.router.registerRoutes({
      path: "/reports/2",
      page: this.createPage({
        Page: Report2Page,
        action: this.showReport2Page.bind(this)
      }),
      options: {
        secure: true,
        role: [RoleConstants.MIK_BO.MIK_OSOBLJE]
      }
    });
    this.router.registerRoutes({
      path: "/reports/3",
      page: this.createPage({
        Page: Report3Page,
        action: this.showReport3Page.bind(this)
      }),
      options: {
        secure: true,
        role: [RoleConstants.MIK_BO.MIK_OSOBLJE]
      }
    });
    this.router.registerRoutes({
      path: "/reports/4",
      page: this.createPage({
        Page: Report4Page,
        action: this.showReport4Page.bind(this)
      }),
      options: {
        secure: true,
        role: [RoleConstants.MIK_BO.MIK_OSOBLJE]
      }
    });
    this.router.registerRoutes({
      path: "/reports/5",
      page: this.createPage({
        Page: Report5Page,
        action: this.showReport5Page.bind(this)
      }),
      options: {
        secure: true,
        role: [RoleConstants.MIK_BO.MIK_OSOBLJE]
      }
    });
    this.router.registerRoutes({
      path: "/reports/8",
      page: this.createPage({
        Page: Report8Page,
        action: this.showReport8Page.bind(this)
      }),
      options: {
        secure: true,
        role: [RoleConstants.MIK_BO.MIK_OSOBLJE]
      }
    });
    this.router.registerRoutes({
      path: "/reports/6",
      page: this.createPage({
        Page: Report6Page,
        action: this.showReport6Page.bind(this)
      }),
      options: {
        secure: true,
        role: [RoleConstants.MIK_BO.MIK_OSOBLJE]
      }
    });
    this.router.registerRoutes({
      path: "/reports/publications",
      page: this.createPage({
        Page: PublicationsReportPage,
        action: this.showPublicationsReportPage.bind(this)
      }),
      options: {
        secure: true,
        role: [RoleConstants.MIK_BO.MIK_OSOBLJE]
      }
    });
    this.router.registerRoutes({
      path: "/reports/7",
      page: this.createPage({
        Page: Report7Page,
        action: this.showReport7Page.bind(this)
      }),
      options: {
        secure: true,
        role: [RoleConstants.MIK_BO.MIK_OSOBLJE]
      }
    });
  }

  public showReport1Page() {
    return this.application.container
      .resolve<ShowReport1PageInteractor>("showReport1Page")
      .execute();
  }
  public showReport2Page() {
    return this.application.container
      .resolve<ShowReport2PageInteractor>("showReport2Page")
      .execute();
  }

  public showReport3Page() {
    return this.application.container
      .resolve<ShowReport3PageInteractor>("showReport3Page")
      .execute();
  }

  public showReport4Page() {
    return this.application.container
      .resolve<ShowReport4Interactor>("showReport4Page")
      .execute();
  }

  public showReport5Page() {
    return this.application.container
      .resolve<ShowReport5PageInteractor>("showReport5Page")
      .execute();
  }
  public showReport8Page() {
    return this.application.container
      .resolve<ShowReport8PageInteractor>("showReport8Page")
      .execute();
  }
  public showReport6Page() {
    return this.application.container
      .resolve<ShowReport6PageInteractor>("showReport6Page")
      .execute();
  }
  public showPublicationsReportPage() {
    return this.application.container
      .resolve<ShowPublicationsReportPageInteractor>(
        "showPublicationsReportPage"
      )
      .execute();
  }
  public showReport7Page() {
    return this.application.container
      .resolve<ShowReport7PageInteractor>("showReport7Page")
      .execute();
  }
}
